// ---------------------------------------------------------------------------
// Scroll-triggered reveal animations
// ---------------------------------------------------------------------------
function initScrollAnimations() {
    const targets = document.querySelectorAll('.animated');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
        targets.forEach((el) => el.classList.add('is-animated'));
        return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-animated');
            obs.unobserve(entry.target);
        });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

    targets.forEach((el) => observer.observe(el));
}

// ---------------------------------------------------------------------------
// Imports
// ---------------------------------------------------------------------------
import { initSiteHeader } from './modules/header.js';
import { initAnchors } from './modules/anchors.js';
import { initHeroWave } from './modules/hero-wave.js';
import { initCaseSlider, initCaseWave } from './modules/case';
import { initTeamSlider } from './modules/team-slider.js';
import { initLogosSlider } from './modules/logos-slider.js';

import { initFaq } from './modules/faq.js';
import { initReviewsSlider } from './modules/slider.js';
import { initCartModal } from './modules/cart-modal.js';
import { initCartQuantity } from './modules/cart-quantity.js';
import { initCheckoutCompany } from './modules/checkout-company.js';
import { initCookieYesLinks } from './modules/cookieyes.js';

// ---------------------------------------------------------------------------
// Boot
// ---------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
    initSiteHeader();
    initAnchors();
    initHeroWave();
    initCaseSlider();
    initCaseWave();
    initTeamSlider();
    initLogosSlider();
    initFaq();
    initReviewsSlider();
    initCartModal();
    initCartQuantity();
    initCheckoutCompany();
    initCookieYesLinks();
    initScrollAnimations();
});
